<template>
  <div class="row">
    <div class="col-sm-12 text-end">
      Already a client. <a href="#" @click="login">Sign in</a>
    </div>
  </div>

  <div class="pt-4 pb-2">
    <h5 class="card-title text-center pb-0 fs-4">Register</h5>
  </div>

  <div class="row g-3 needs-validation" novalidate>
    <div class="col-12">
      <label for="txtNameClient" class="form-label">*Name</label>

      <input type="text" class="form-control" id="txtNameClient" v-model="user.Name" required />
      <div class="invalid-feedback">Please enter your Name.</div>
    </div>


    <div class="col-12">
      <label for="txtBusinessName" class="form-label">*Business name</label>

      <input type="text" class="form-control" id="txtBusinessName" v-model="user.Company" required />
      <div class="invalid-feedback">Please enter your Business Name.</div>
    </div>

    <div class="col-12">
      <label for="txtBusinessName" class="form-label">*Business address</label>

      <input type="text" class="form-control" id="txtBusinessAddress" v-model="user.Address" required />
      <div class="invalid-feedback">Please enter your Business Address.</div>
    </div>

    <div class="col-12">
      <label for="txtPhone" class="form-label">Direct phone number</label>

      <input type="text" class="form-control" id="txtPhone" v-model="user.Contact" required />
      <div class="invalid-feedback">Please enter your Phone.</div>
    </div>

    <div class="col-12">
      <label for="txtPhone" class="form-label">Business phone number</label>
      <input type="text" class="form-control" id="txtBusinessPhone" v-model="user.ClientPhone" />
    </div>

    <div class="col-12">
      <label for="txtEmail" class="form-label">*Role</label>

      <input type="text" class="form-control" id="txtEmail" v-model="user.Role" required />
      <div class="invalid-feedback">Please enter a role.</div>
    </div>

    <div class="col-12">
      <label for="txtEmail" class="form-label">*Email</label>

      <input type="text" class="form-control" id="txtEmail" v-model="user.Username" required />
      <div class="invalid-feedback">Please enter your Email.</div>
    </div>

    <div class="col-12">
      <label for="txtPassword" class="form-label">*Create a password</label>

      <input type="password" class="form-control" id="txtPassword" v-model="user.Password" required />
      <div class="invalid-feedback">Please enter your password.</div>
    </div>

    <div class="col-12">
      <label for="txtRepeatPassword" class="form-label">*Re-type Password</label>

      <input type="password" class="form-control" id="txtRepeatPassword" v-model="user.RepeatPassword" required />
      <div class="invalid-feedback">Please re enter your password.</div>
    </div>

    <div class="col-12">
      <ul class="no-bullets">
        <li v-if="error.incomplete == true" class="text-danger">Enter the requested information</li>
        <li v-if="error.already == true" class="text-danger">The mail {{ user.Username }} is already registered</li>
        <li v-if="error.badPassword == true" class="text-danger">The keys does not match</li>
        <li v-if="error.badMail == true" class="text-danger">The mail is in the wrong format</li>
      </ul>
    </div>

  </div>

  <div class="row mt-5">
    <div class="col-sm-12 text-end">
      <loadingbutton :loading="isLoading" @pressed="register" :classButton="'btn btn-primary w-100'"
        :icon="'bi bi-save'" buttonText="Save" />
    </div>
  </div>
</template>

<script>
import loadingbutton from "@/components/global/loading-button.vue";

export default {
  components: { loadingbutton },
  emits: ['saved'],
  data: function () {
    return {
      user: { Company: '', Name: '', Position: '', Contact: '',ClientPhone:'', Role: '', Username: '', Password: '', RepeatPassword: '' },
      error: { incomplete: false, already: false, badPassword: false, badMail: false },
      isLoading: false
    }
  },
  mounted() {
  },
  methods: {
    register() {
      let self = this;
      console.log("user", this.user);

      if (this.thereIsError()) { return false; }

      this.$vtc.vtcFetch("/Auth/Register", this.user, 'API2').then(function (data) {
        console.log("data", data);
        if (data === false) {
          //self.error.already = true;//verificando
          console.log(data);
        } else {
          let usr = data;
          let tk = usr.token;
          self.$vtc.setUserToken(tk)
          self.$vtc.setUsuarioLogueado(usr)
          self.$vtc.setNameLogueado(usr.name);

          self.$emit('registered', usr)
        }
      }).catch(function (e) {
        console.log("ERROR -> ", e);
        if (e.codigo == 101) self.error.incomplete = true;
        if (e.codigo == 102) self.error.already = true;
      });
    },
    login() {
      this.$emit('notregister')
    },
    thereIsError() {
      this.error.incomplete = false;
      this.error.badPassword = false;
      this.error.badMail = false;

      if (this.user.Name == "") { this.error.incomplete = true; }
      if (this.user.Company == "") { this.error.incomplete = true; }
      if (this.user.Address == "") { this.error.incomplete = true; }
      //if (this.user.Contact == "") { this.error.incomplete = true; }
      if (this.user.Role == "") { this.error.incomplete = true; }
      if (this.user.Username == "") { this.error.incomplete = true; }
      if (this.user.Password == "") { this.error.incomplete = true; }
      if (this.user.RepeatPassword == "") { this.error.incomplete = true; }

      if (this.user.Password != this.user.RepeatPassword) this.error.badPassword = true;

      if (this.user.Username != "" && !this.isValidEmailAddress(this.user.Username)) this.error.badMail = true;

      return (this.error.incomplete || this.error.badPassword || this.error.badMail);
    },

    isValidEmailAddress(mail) {
      var pattern = new RegExp(/^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i);
      return pattern.test(mail);
    }
  },
  computed: {
  },

}
</script>
<style scoped>
ul.no-bullets {
  list-style-type: none;
  /* Remove bullets */
  padding: 0;
  /* Remove padding */
  margin: 0;
  /* Remove margins */
}
</style>